import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

export default {
  setStep({ commit }, step) {
    commit(types.SET_STEP, step)
  },
  async verifyAddress({ commit, dispatch }, address) {
    const r = await startLoading(dispatch, 'verifyAddress', () =>
      http.get('data/VerifyAddress', { params: { ...address } })
    )
    return r.data
  },
  async processAddresses({ commit, dispatch }) {
    await startLoading(dispatch, 'processAddresses', () =>
      http.get('data/ProcessDatabaseAddresses')
    )
    // todo(bwills): re-enable this if we return address data
    /*
    const r = await startLoading(dispatch, 'processAddresses', () =>
      http.get('data/ProcessDatabaseAddresses')
    )
    commit(types.SET_ADDRESSES, r.data)
    */
  },
  async getVerifiedAddresses({ commit }) {
    const r = await http.get('data/GetDataVerifiedAddresses')
    commit(types.SET_ADDRESSES, r.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/usps/actions.js